import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRandomValue } from '../../../store/storeFunctions';
import { withLocalize } from 'react-localize-redux';
import classnames from 'classnames';
import MarkIcon from '../../../img/icons/BBicons_Zalozka'

import BbPopover from '../../common/popover'

class RatingCard extends React.Component {
    state = { tooltipOpen: false, bodyTooltipOpen: false, id: getRandomValue().toString(), tooltipDetailOpen: false };

    resizerTimeouts = {}

    componentWillUnmount() {
        Object.keys(this.resizerTimeouts).forEach(timeout => clearTimeout(this.resizerTimeouts[timeout]));
    }

    render() {
        let popoverId = `header-tooltip-${this.state.id}-${this.props.cardType}`;

        return (
            <div className={classnames('rating-card', { 'rating-card-white': this.props.white, 'aligned': this.props.aligned, 'has-footer':this.props.hasFooter })}>
                <span>
                    {this.props.tooltip &&
                        <BbPopover title={this.props.title} content={this.props.tooltip} addInfo={this.props.cardType} placement="left" targetId={popoverId}>
                            <span href="#" className="icon-gray print-hidden" id={popoverId} style={{ cursor: "pointer" }}><FontAwesomeIcon icon="question-circle" /></span>
                        </BbPopover>
                    }
                </span>
                <div className="rating-header">
                    <span className="rating-header-body">
                        <span className='underlined-title-wrapper'>                           
                            <span className='underlined-title'>
                                <span>{this.props.title}
                                    {typeof this.props.onFurtherInfoLinkClick === 'function' &&
                                    <span className='further-info-link'>
                                        <span className="icon-gray" title={this.props.translate("Common.MoreInformation")} onClick={this.props.onFurtherInfoLinkClick}>
                                            <MarkIcon id={`detail-tooltip-${this.state.id}`} className='with-pointer' />
                                        </span>
                                    </span>}
                                </span>
                            </span>                       
                        </span>
                    </span>
                </div>
                <div className={classnames({ "rating-body": true, "align-top": this.props.alignTop })}>                  
                    <div href="#" className='w-100' id={`body-tooltip-${this.state.id}-${this.props.cardType}`} style={{ height: "100%" }}>
                        <div className="rating-description" style={{ fontWeight: this.props.bold ? "600" : "400" }}>{this.props.children}</div>
                    </div>
                </div>
                {this.props.footer && <div className='rating-footer'>
                    {this.props.footer}
                </div>}
            </div>
        )
    } 
}

export default withLocalize(connect(state => state.report)(RatingCard));
